export default "__VITE_ASSET__b9fc3dd3__"